import sharedUtils from "../grid/sharedUtilities";
import { cardSections, queryCard, QueryFormResponse, QueryFormSubmitRequest, ResolveSubmitRequest } from "../../services/QueryService";
import { LookupTypeItem, VenueLookupTypeItem } from "../../services/LookupService";
import { ServiceType } from "../../common/ServiceUtilities";
import { NullableDate } from "../Outstanding-Actions/OutstandingActionsUtilities";
import { queryStatusType } from "../../services/CostReportService";

export interface QueryFormObject {
    id: string,
    queryStatusId: string,
    queryStatus: string,
    queryTitle: string,
    queryDescription: string,
    resolutionReason: string,
    internalOnly: boolean,
    queryCategoryId: string,
    queryCategoryDescription: string,
    queryResolutionCategoryId: string,
    queryResolutionCategoryDescription: string,
    resolvedDate: string | null,
    firstResponseDateTime: string | null,
    billableItemId: string,
    dateCreated: NullableDate,
    venueId: string,
    providerBusinessEntityId: string,
    venue: string,
    venueName: string,
    comments: string,
    lastUpdate: string,
    serviceTypeId: string,
    serviceTypeValue: string,
    serviceSubTypeId: string,
    queryTypeLookupID: string,
    queryTypeLookupValue: string,
    lastUpdatedBy: string,
    businessEntityId: string,
    businessEntityTypeText: string,
    raisedByContactName: string,
    raisedByContactTelNumber: string,
    queryRaisedBy:string,
    typeLookupId: string,
    typeLookupValue: string,
    queryTypeText: string,
    queryTypeEnum: number,
    activity_Comments?: string,
    activity_Type?: string,
    activity_LastUpdatedBy?: string,
    activity_LastUpdated?: string,
    activity_external?: string,
    activity_RaisedBy?: string,
    activity: [{
        id: string,
        query_Id: string,
        activity_Comments: string,
        activity_Type: string,
        activity_LastUpdatedBy: string,
        activity_LastUpdated: string,
        activity_external: boolean,
        activity_RaisedBy?: string,
    }],
    internal_Comment: string,
    validationErrors: [],
    user: [{
        id: string,
        name: string
    }],
    lastUpdated_DateTime: string,
    clientId: string,
    contactId: string,
    queryClientBusinessEntityId: string,
    queryClientBusinessEntityValue: string,
    queryServiceTypeId: string,
    queryServiceTypeValue: string,
    queryRaisedTime: NullableDate,
    queryDateCreated: string,
    app: string,
    linkedId: string,
    newActivity: boolean
}

export interface QueryResolveObject {
    id: string,
    resolutionreason: string
}

export default class queryUtils {
    utils: sharedUtils;
    constructor() {
        this.utils = new sharedUtils();
        this.initializeQueryItem = this.initializeQueryItem.bind(this);
        this.convertQueryResponeToFormData = this.convertQueryResponeToFormData.bind(this);
        this.convertFormDataToQueryRequest = this.convertFormDataToQueryRequest.bind(this);
    }

    initializeCardSections = (): cardSections => {
        var accordionSectionData: cardSections = {
            security: [],
            cleaning: [],
            entertainment: [],
            general: [],
        };
        return accordionSectionData;
    };

    //Helper function that will get the response i.e; Query card List data and would group them by service.
    groupCardListByService = (queryCardList: queryCard[]): cardSections => {
        var cardAccordionSectionByService: cardSections = this.initializeCardSections();
        queryCardList.forEach((queryItem: queryCard) => {
            if (queryItem.serviceTypeId == ServiceType.Security) {
                cardAccordionSectionByService.security.push(queryItem);
            } else if (queryItem.serviceTypeId == ServiceType.ContractCleaning) {
                cardAccordionSectionByService.cleaning.push(queryItem);
            } else if (queryItem.serviceTypeId == ServiceType.Entertainment) {
                cardAccordionSectionByService.entertainment.push(queryItem);
            } else {
                cardAccordionSectionByService.general.push(queryItem);
            }
        });
        return cardAccordionSectionByService;
    };

    extractVenueListBasedOnClient = (venueList: VenueLookupTypeItem[], clientId: string): VenueLookupTypeItem[] => {
        var lookupType: VenueLookupTypeItem = {
            id: "0",
            value: "ALL",
            postCode: "",
            parentMappingId: "0",
            venueTypeId: ""
        };
        var listOfVenues: VenueLookupTypeItem[] = venueList.filter((item) => {
            return item.parentMappingId == clientId;
        });
        return [lookupType].concat(listOfVenues);
    };

    lookUpRaisedBy = (): LookupTypeItem[] => {
        let raisedByList: LookupTypeItem[] = [];
        raisedByList = [{
            id: "0",
            value: "ALL",
            parentMappingId: "0",
        },
        {
            id: "10",
            value: "Client",
            parentMappingId: "0",
        },
        {
            id: "30",
            value: "Event",
            parentMappingId: "0",
        },
        {
            id: "20",
            value: "Provider",
            parentMappingId: "0",
        }]
        return raisedByList;
    };

    lookUpincludeAll = (serviceList: LookupTypeItem[]): LookupTypeItem[] => {
        var lookupType: LookupTypeItem = {
            id: "0",
            value: "ALL",
            parentMappingId: "0",
        };
        return [lookupType].concat(serviceList);
    };

    /**
     * Returns the category lookup items mapped (via parentMappingId) to the selected app.
     * Falls back to the full list when no app is selected or the lookup carries no app mapping.
     */
    filterCategoryLookupByApp = (items: LookupTypeItem[], appId: string): LookupTypeItem[] => {
        if (!appId || items.length === 0) {
            return items;
        }
        const hasAppMapping = items.some((item) => item.parentMappingId !== null && item.parentMappingId !== undefined && String(item.parentMappingId).trim() !== "");
        if (!hasAppMapping) {
            return items;
        }
        return items.filter((item) => String(item.parentMappingId) === String(appId));
    };

    /**
     * Memoised filterCategoryLookupByApp - returns the same array until the items or app change.
     * DevExtreme reloads a SelectBox whenever its dataSource prop changes identity, so a fresh
     * array on every render makes the dropdowns sluggish.
     */
    createCategoryLookupFilter = (): ((items: LookupTypeItem[], appId: string) => LookupTypeItem[]) => {
        let lastItems: LookupTypeItem[] | null = null;
        let lastAppId: string = "";
        let lastResult: LookupTypeItem[] = [];
        return (items: LookupTypeItem[], appId: string) => {
            if (items !== lastItems || appId !== lastAppId) {
                lastItems = items;
                lastAppId = appId;
                lastResult = this.filterCategoryLookupByApp(items, appId);
            }
            return lastResult;
        };
    };

    /**
     * The "Please state the ..." boxes are free text only - the selected category is already sent by id.
     * Earlier versions copied the dropdown text into the description, so drop it when it only repeats the selected item.
     */
    getFreeTextDescription = (description: string, categoryId: string, items: LookupTypeItem[]): string => {
        const category = items.find((item) => String(item.id) === String(categoryId));
        if (!description || !category) {
            return description || "";
        }
        return description.trim().toLowerCase() === String(category.value).trim().toLowerCase() ? "" : description;
    };

    initializeQueryResolveItem(_idFromGrid: string): QueryResolveObject {
        var formData: QueryResolveObject = {
            id: "",
            resolutionreason: ""
        }
        return formData;
    }

    initializeQueryItem(_idFromGrid: string): QueryFormObject {
        var formData: QueryFormObject = {
            id: "",
            queryStatusId: "",
            queryStatus: "",
            queryTitle: "",
            queryDescription: "",
            resolutionReason: "",
            internalOnly: false,
            queryCategoryId: "",
            queryCategoryDescription: "",
            queryResolutionCategoryId: "",
            queryResolutionCategoryDescription: "",
            resolvedDate: "",
            firstResponseDateTime: null,
            billableItemId: "",
            dateCreated: undefined,
            venueId: "",
            providerBusinessEntityId: "",
            venue: "",
            venueName: "",
            comments: "",
            lastUpdate: "",
            serviceTypeId: "",
            serviceTypeValue: "",
            serviceSubTypeId: "",
            queryTypeLookupID: "",
            queryTypeLookupValue: "",
            lastUpdatedBy: "",
            businessEntityId: "",
            businessEntityTypeText: "",
            raisedByContactName: "",
            raisedByContactTelNumber: "",
            queryRaisedBy:"",
            typeLookupId: "",
            typeLookupValue: "",
            queryTypeText: "",
            queryTypeEnum: 0,
            activity_Comments: "",
            activity_Type: "",
            activity_LastUpdatedBy: "",
            activity_LastUpdated: "",
            activity_external: "",
            activity_RaisedBy: "",
            activity: [{
                id: "0",
                query_Id: "",
                activity_Comments: "",
                activity_Type: "",
                activity_LastUpdatedBy: "",
                activity_LastUpdated: "",
                activity_external: false,
                activity_RaisedBy: "",
            }],
            internal_Comment: "",
            validationErrors: [],
            user: [{
                id: "",
                name: ""
            }],
            lastUpdated_DateTime: "",
            clientId: "",
            contactId: "",
            queryClientBusinessEntityId: "",
            queryClientBusinessEntityValue: "",
            queryServiceTypeId: "",
            queryServiceTypeValue: "",
            queryRaisedTime: null,
            queryDateCreated: "",
            app: "",
            linkedId: "",
            newActivity: false
        }
        return formData;
    }

    // Convert the server response into the component's form state
    convertQueryResponeToFormData(serverResponse: QueryFormResponse): QueryFormObject {
        var formData: QueryFormObject = {
            id: serverResponse.id,
            queryStatusId: serverResponse.queryStatusId,
            queryStatus: serverResponse.queryStatus,
            queryTitle: serverResponse.queryTitle,
            queryDescription: serverResponse.queryDescription,
            resolutionReason: serverResponse.resolutionReason,
            internalOnly: serverResponse.internalOnly === true || String(serverResponse.internalOnly).toLowerCase() === "true" || String(serverResponse.internalOnly) === "1",
            queryCategoryId: serverResponse.queryCategoryId,
            queryCategoryDescription: serverResponse.queryCategoryDescription,
            queryResolutionCategoryId: serverResponse.queryResolutionCategoryId,
            queryResolutionCategoryDescription: serverResponse.queryResolutionCategoryDescription,
            resolvedDate: serverResponse.resolvedDate,
            firstResponseDateTime: serverResponse.firstResponseDateTime,
            billableItemId: serverResponse.billableItemId,
            dateCreated: this.utils.convertStringToFormattedDate(serverResponse.dateCreated),
            venueId: serverResponse.venueId,
            providerBusinessEntityId: serverResponse.providerBusinessEntityId, 
            venue: serverResponse.venue,
            venueName: serverResponse.venueName,
            comments: serverResponse.comments,
            lastUpdate: serverResponse.lastUpdate,
            serviceTypeId: serverResponse.serviceTypeId,
            serviceTypeValue: serverResponse.serviceTypeValue,
            serviceSubTypeId: serverResponse.serviceSubTypeId,
            queryTypeLookupID: serverResponse.queryTypeLookupID,
            queryTypeLookupValue: serverResponse.queryTypeLookupValue,
            lastUpdatedBy: serverResponse.lastUpdatedBy,
            businessEntityId: serverResponse.businessEntityId,
            businessEntityTypeText: serverResponse.businessEntityTypeText,
            raisedByContactName: serverResponse.raisedByContactName,
            raisedByContactTelNumber: serverResponse.raisedByContactTelNumber,
            queryRaisedBy:serverResponse.queryRaisedBy,
            typeLookupId: serverResponse.typeLookupId,
            typeLookupValue: serverResponse.typeLookupValue,
            queryTypeText: serverResponse.queryTypeText,
            queryTypeEnum: serverResponse.queryTypeEnum,
            activity: serverResponse.activity,
            internal_Comment: serverResponse.internal_Comment,
            validationErrors: serverResponse.validationErrors,
            user: serverResponse.user,
            lastUpdated_DateTime: serverResponse.lastUpdated_DateTime,
            clientId: serverResponse.clientId,
            contactId: serverResponse.contactId,
            queryClientBusinessEntityId: serverResponse.queryClientBusinessEntityId,
            queryClientBusinessEntityValue: serverResponse.queryClientBusinessEntityValue,
            queryServiceTypeId: serverResponse.queryServiceTypeId,
            queryServiceTypeValue: serverResponse.queryServiceTypeValue,
            queryRaisedTime: this.utils.convertStringToTime(serverResponse.queryRaisedTime),
            queryDateCreated: serverResponse.queryDateCreated,
            app: (serverResponse as any).app ? String((serverResponse as any).app) : "",
            linkedId: serverResponse.linkedId,
            newActivity: serverResponse.newActivity === true || String(serverResponse.newActivity).toLowerCase() === "true"
        };

        return formData;
    }

    /**
     * Parses activity timestamps into a Date, supporting the UK display format
     * used by the API (e.g. "Wed 23 Sep 2026 09:23:40") which native Date cannot parse reliably.
     * Returns null when the value cannot be interpreted as a valid date.
     */
    parseActivityDate = (value: string): Date | null => {
        if (!value) {
            return null;
        }
        // Extract "dd MMM yyyy HH:mm:ss" ignoring any leading weekday (e.g. "Wed ").
        const ukFormatMatch = String(value).match(/(\d{1,2})\s+([A-Za-z]{3})[A-Za-z]*\s+(\d{4})\s+(\d{1,2}):(\d{2})(?::(\d{2}))?/);
        if (ukFormatMatch) {
            const monthIndex = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"]
                .indexOf(ukFormatMatch[2].toLowerCase());
            if (monthIndex >= 0) {
                const parsed = new Date(
                    Number(ukFormatMatch[3]),
                    monthIndex,
                    Number(ukFormatMatch[1]),
                    Number(ukFormatMatch[4]),
                    Number(ukFormatMatch[5]),
                    Number(ukFormatMatch[6] || 0)
                );
                if (!isNaN(parsed.getTime())) {
                    return parsed;
                }
            }
        }
        const nativeDate = new Date(value);
        return isNaN(nativeDate.getTime()) ? null : nativeDate;
    }

    /**
     * Determines the very first (earliest) external activity_LastUpdated timestamp
     * from the activity list where activity_external is true.
     * Ensures every POST carries firstResponseDateTime = time of the first external activity.
     */
    getFirstExternalResponseByUs = (activities: any[]): string | null => {
        if (!Array.isArray(activities)) {
            return null;
        }
        const externalDates = activities
            .filter((activityItem) => {
                const isExternal = activityItem?.activity_external === true
                    || String(activityItem?.activity_external).toLowerCase() === "true"
                    || String(activityItem?.activity_external) === "1";
                return isExternal && !!activityItem?.activity_LastUpdated;
            })
            .map((activityItem) => this.parseActivityDate(activityItem.activity_LastUpdated))
            .filter((activityDate): activityDate is Date => activityDate !== null)
            .sort((first, second) => first.getTime() - second.getTime());
        return externalDates.length > 0 ? externalDates[0].toISOString() : null;
    }

    convertFormDataToQueryRequest(
        formData: QueryFormObject,
        navigation: string
    ): QueryFormSubmitRequest {
        let queryStatusId: string = "";
        let queryStatus: string = formData.queryStatus;
        if (navigation == "resolved") {
            queryStatusId = queryStatusType.Resolved;
            queryStatus = "Resolved";
        }
        else if (navigation == "closed") {
            queryStatusId = queryStatusType.Closed;
            queryStatus = "Close";
        }
        else if (!formData.id) {
            queryStatusId = queryStatusType.Pending;
        }
        else {
            queryStatusId = formData.queryStatusId;
        }
        let queryDateCreated: string = "";
        if(formData.id){
            queryDateCreated = formData.queryDateCreated;
        }
        else {
            queryDateCreated =  this.utils.convertDateToString(new Date(formData.queryDateCreated));
        }
        const resolvedDateValue = formData.resolvedDate
            ? new Date(formData.resolvedDate as string)
            : null;
        const resolvedDate = resolvedDateValue && !isNaN(resolvedDateValue.getTime())
            ? resolvedDateValue.toISOString()
            : null;
        // firstResponseDateTime is intentionally not submitted in POST payloads.
        // The value is read directly from the GET payload in the QueryGrid display layer.
        // Original logic retained for reference only:
        // let firstResponseDateTimeRaw: string | null = this.getFirstExternalResponseByUs(formData.activity);
        // if (!firstResponseDateTimeRaw && formData.firstResponseDateTime) {
        //     firstResponseDateTimeRaw = formData.firstResponseDateTime;
        // }
        // if (!firstResponseDateTimeRaw) {
        //     const newActivityIsExternal = formData.activity_external == "Yes"
        //         || formData.activity_external == "True"
        //         || formData.activity_external == "1";
        //     if (newActivityIsExternal && formData.activity_Comments && formData.activity_Comments.trim()) {
        //         firstResponseDateTimeRaw = new Date().toISOString();
        //     }
        // }
        // const firstResponseDateValue = firstResponseDateTimeRaw
        //     ? this.parseActivityDate(firstResponseDateTimeRaw)
        //     : null;
        // const firstResponseDateTime = firstResponseDateValue
        //     ? firstResponseDateValue.toISOString()
        //     : null;
        var submitRequest: QueryFormSubmitRequest = {
            id: formData.id,
            queryStatusId: queryStatusId,
            queryStatus: queryStatus,
            queryTitle: formData.queryTitle,
            queryDescription: formData.queryDescription,
            resolutionReason: formData.resolutionReason,
            internalOnly: formData.internalOnly,
            queryCategoryId: formData.queryCategoryId,
            queryCategoryDescription: formData.queryCategoryDescription,
            queryResolutionCategoryId: formData.queryResolutionCategoryId,
            queryResolutionCategoryDescription: formData.queryResolutionCategoryDescription,
            resolvedDate: resolvedDate,
            // firstResponseDateTime: firstResponseDateTime,
            billableItemId: formData.billableItemId,
            dateCreated: this.utils.convertDateToString(formData.dateCreated),
            venueId: formData.venueId,
            providerBusinessEntityId: formData.providerBusinessEntityId,
            venue: formData.venue,
            venueName: formData.venueName,
            comments: formData.comments,
            lastUpdate: formData.lastUpdate,
            serviceTypeId: formData.serviceTypeId,
            serviceTypeValue: formData.serviceTypeValue,
            serviceSubTypeId: formData.serviceSubTypeId,
            queryTypeLookupID: formData.queryTypeLookupID,
            queryTypeLookupValue: formData.queryTypeLookupValue,
            lastUpdatedBy: formData.lastUpdatedBy,
            businessEntityId: formData.businessEntityId,
            businessEntityTypeText: formData.businessEntityTypeText,
            raisedByContactName: formData.raisedByContactName,
            raisedByContactTelNumber: formData.raisedByContactTelNumber,
            typeLookupId: formData.typeLookupId,
            typeLookupValue: formData.typeLookupValue,
            queryTypeText: formData.queryTypeText,
            queryTypeEnum: formData.queryTypeEnum,
            activity_Comments: formData.activity_Comments ? formData.activity_Comments : "",
            activity_Type: formData.activity_Type ? formData.activity_Type : "",
            activity_LastUpdatedBy: formData.activity_LastUpdatedBy ? formData.activity_LastUpdatedBy : "",
            activity_LastUpdated: formData.activity_LastUpdated ? formData.activity_LastUpdated : "",
            activity_external: formData.activity_external == "Yes" || formData.activity_external == "True"  || formData.activity_external == "1" ? true : false,
            internal_Comment: formData.internal_Comment,
            clientId: formData.clientId,
            contactId: formData.contactId,
            queryClientBusinessEntityId: formData.queryClientBusinessEntityId,
            queryClientBusinessEntityValue: formData.queryClientBusinessEntityValue,
            queryServiceTypeId: formData.queryServiceTypeId,
            queryServiceTypeValue: formData.queryServiceTypeValue,
            queryRaisedTime: this.utils.convertTimeToString(formData.queryRaisedTime),
            queryDateCreated: queryDateCreated,
            app: (formData as any).app ? String((formData as any).app) : "",
            linkedId: formData.linkedId,
            newActivity: !!formData.newActivity
        };

        return submitRequest;
    }

    

    convertFormDataToResolveQueryRequest(formData: QueryResolveObject) {
        var submitRequest: ResolveSubmitRequest = {
            id: formData.id,
            resolutionreason: formData.resolutionreason
        }
        return submitRequest;
    }
}
